// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Jxl_","select":"styles_select__2G83x"};